<template>
  <div class="contents4">
    <!-- pc -->
    <img class="bg" src="static/img/service/bg_white.png" v-show="!isMobile" />
    <div class="contents" v-show="!isMobile">
      <div class="img">
        <img src="static/img/service/site_service_img_04.png" />
      </div>
      <div class="text">
        <div class="wrap">
          <div class="icon">
            <img src="static/img/icon_computer.png" />
          </div>
          <div class="title">B2B <span>관제 서비스</span></div>
          <div class="body">
            <p>
              효율적인 차량 운영 관리를 위한 스마트 관제 시스템 제공
            </p>
            <p>
              · 스마트 관제 시스템을 통한 실시간 모니터링 가능<br />
              · 전국 순회 정비망 구축<br />
              · B2B 파트너사 보유 차량 누적 100만대 관리 중
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/contact?tab=corporate-vehicle')"><img src="static/img/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="contents" v-show="isMobile">
      <div class="img">
        <img src="static/img/mobile/service/site_service_img_04_m.png" />
      </div>
      <div class="text">
        <img src="static/img/mobile/service/background_white_04.png" />
        <div class="wrap">
          <div class="icon">
            <img src="static/img/mobile/service/icon_computer.png" />
          </div>
          <div class="title">B2B <span>관제 서비스</span></div>
          <div class="body">
            <p>효율적인 차량 운영 관리를 위한 <br />스마트 관제 시스템 제공</p>
            <p>
              · 스마트 관제 시스템을 통한<br />
              <span style="margin-left:3%;">실시간 모니터링 가능</span><br />
              · 전국 순회 정비망 구축<br />
              · B2B 파트너사 보유 차량<br />
              <span style="margin-left:3%;"> 누적 100만대 관리 중</span><br />
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/contact?tab=corporate-vehicle')"><img src="static/img/mobile/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    },
    gotoPage(path) {
      window.open(path)
    }
  }
}
</script>

<style scoped>
.contents4 {
  width: 100%;
  position: relative;
}
.contents4 .bg {
  width: 100%;
  height: auto;
  display: block;
}
@media (max-width: 1280px) {
  .contents4 .contents .icon img {
    width: 32px;
    height: auto;
  }
  .contents4 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents4 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents4 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .contents4 .contents .btn img {
    width: 160px;
    height: auto;
  }
}
@media (min-width: 1280px) {
  .contents4 .contents .icon img {
    width: 2.5vw;
    height: auto;
  }
  .contents4 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents4 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents4 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .contents4 .contents .btn img {
    width: 12vw;
    height: auto;
  }
}
@media (min-width: 641px) {
  .contents4 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .contents4 .text {
    width: 50%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contents4 .img {
    width: 50%;
    height: 100%;
    float: left;
  }
  .contents4 .img img {
    width: 100%;
    height: 100%;
  }
  .contents4 .contents .body p {
    margin: 5% 0;
  }
  .contents4 .contents .btn {
    margin-top: 15%;
  }
  .contents4 .contents .btn a {
    cursor: pointer;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents4 .img img {
    width: 100%;
    height: 100%;
  }
  .contents4 .text {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .contents4 .text img {
    width: 100%;
    height: 100%;
  }
  .contents4 .text .wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 0 0 0 5%;
  }
  .contents4 .contents .icon img {
    width: 8vw;
    height: auto;
  }
  .contents4 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents4 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents4 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 4.3vw;
    line-height: 6.5vw;
    color: #444444;
  }
  .contents4 .contents .btn img {
    width: 50vw;
    height: auto;
  }
  .contents4 .contents .icon {
    margin-top: 15%;
    margin-bottom: 5%;
  }
  .contents4 .contents .body p {
    margin: 5% 0;
  }
  .contents4 .contents .btn {
    margin-top: 15%;
  }
  .contents4 .contents .btn a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/service/Contents4.vue